import type { Sizes } from '@/runtime/types';
import type { PropDoc } from '@/runtime/shared';

export interface IconProps {
  /* The name of the icon (fileName - '.svg') */
  name: string;
  /* The size of the icon
   * When `undefined`, the icon will inherit the size of the parents font.
   */
  size?: Sizes;
}

type IconPropKeys = keyof IconProps;

export const iconPropsDocs: Record<IconPropKeys, PropDoc> = {
  name: {
    name: 'name',
    type: 'string',
    descriptionKey: 'icon.name.description'
  },
  size: {
    name: 'size',
    type: `'xs' | 'sm' | 'md' | 'lg' | 'xl'`,
    descriptionKey: 'icon.size.description'
  }
} as const;
